// query-string v9 uses export default with named methods attached
import queryString from 'query-string'

// re-export methods with our own types

type Parse = (input: string) => Record<string, string | string[] | undefined>
type Stringify = (input: object) => string

export const parse: Parse = queryString.parse as unknown as Parse
export const stringify: Stringify = queryString.stringify

export const pickQueries = (queries: Record<string, string | string[] | undefined>) => (key: string) => {
  const pVal = queries[key]
  return pVal && pVal instanceof Array ? pVal[0] : pVal
}
